import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "@components/not-found/not-found";

const UserValidationComponent = React.lazy(() => import('@modules/user-validation/user-validation'));
const ResendLinkComponent = React.lazy(() => import('@modules/user-validation/resend-validation-link'));
const EmailConfirmStatusAppointment = React.lazy(
  () => import('@modules/user-validation/emailConfirmStatusAppointment')
);

const UserValidationRoutes = () => {
    return (
        <Routes>
            <Route path="/:username/:code" element={<UserValidationComponent />} />
            <Route path="/resend-link" element={<ResendLinkComponent />} />
            <Route path="/confirm-status-appointment" element={<EmailConfirmStatusAppointment />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
};

export default UserValidationRoutes;
